import React from 'react';
export class UfoErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    for (const exp of this.props.experiences) {
      const {
        name,
        message
      } = error;
      const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
      exp.failure({
        metadata: {
          source: 'UfoErrorBoundary',
          reason: 'error',
          error: {
            name,
            message,
            infoStack
          }
        }
      });
    }
  }
  render() {
    return this.props.children;
  }
}